import uniqBy from "lodash/uniqBy";

const getNavigationItemObjects = (data) =>
  data.filter(({ type }) => type === "story");

const removeSecondSpreads = (data) =>
  data.filter((pageObject) => pageObject.part === 1);

export const pagesToNavItems = (pages) => {
  const a = getNavigationItemObjects(pages);
  const b = removeSecondSpreads(a);
  const c = uniqBy(b, "url");
  return c.map((d) => ({
    id: d.id,
    letter: d.letter,
    defaultCharacter: d.default_character,
    type: d.characters.length > 0 ? "character" : "helper",
    characters:
      d.characters.length > 0
        ? d.characters
        : [
            {
              letter: d.letter,
              character: d.default_character,
              thumbnail: d.thumbnail,
            },
          ],
  }));
};

export const getTransformAmount = (index, windowWidth) => {
  const containerWidth = windowWidth - 100;
  const transform = index * 50;
  return transform < containerWidth ? 0 : containerWidth - transform;
};

export const getTransform = (index, windowWidth) =>
  `translateX(${getTransformAmount(index, windowWidth)}px)`;
